export interface SymbiosisSwapRequestOptions {
    slippage: number;
    receiverAddress?: string;
    fromAddress?: string;
}
